if (!customElements.get('skin-school-glossary')) {
  class SkinSchoolGlossary extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-glossary-input]');
      this.items = Array.from(this.querySelectorAll('[data-glossary-item]'));
      this.list = this.querySelector('[data-glossary-list]');
      this.toggle = this.querySelector('[data-glossary-toggle]');
      this.emptyState = this.querySelector('[data-glossary-empty]');
      this.count = this.querySelector('[data-glossary-count]');
      this.listRevealed = false;

      if (!this.input || this.items.length === 0) return;

      this.input.addEventListener('input', this.handleInput.bind(this));

      if (this.toggle) {
        this.toggle.addEventListener('click', () => this.showAll());
      }

      if (this.count) {
        this.count.textContent = `${this.items.length} ingredients`;
      }
    }

    handleInput(event) {
      const query = event.target.value;

      if (query.length > 0) {
        this.revealList();
        this.filterResults(query);
      } else if (this.listRevealed) {
        this.showAll();
      } else {
        this.hideList();
      }
    }

    showAll() {
      this.revealList();
      this.items.forEach((item) => { item.hidden = false; });

      if (this.toggle) {
        this.toggle.hidden = true;
      }

      if (this.emptyState) {
        this.emptyState.hidden = true;
      }

      if (this.count) {
        this.count.textContent = `${this.items.length} ingredients`;
      }

      this.listRevealed = true;
    }

    hideList() {
      if (this.list) {
        this.list.hidden = true;
      }

      if (this.toggle) {
        this.toggle.hidden = false;
      }

      if (this.emptyState) {
        this.emptyState.hidden = true;
      }

      if (this.count) {
        this.count.textContent = `${this.items.length} ingredients`;
      }
    }

    revealList() {
      if (this.list) {
        this.list.hidden = false;
      }

      if (this.toggle) {
        this.toggle.hidden = true;
      }
    }

    filterResults(query) {
      const normalizedQuery = this.normalize(query);
      let visibleCount = 0;

      this.items.forEach((item) => {
        const matches = this.normalize(item.dataset.search || '').includes(normalizedQuery);
        item.hidden = !matches;

        if (!matches) {
          item.removeAttribute('open');
          return;
        }

        visibleCount += 1;
      });

      if (this.emptyState) {
        this.emptyState.hidden = visibleCount !== 0;
      }

      if (this.count) {
        this.count.textContent = `${visibleCount} result${visibleCount === 1 ? '' : 's'}`;
      }
    }

    normalize(value) {
      return value.toLowerCase().replace(/\s+/g, ' ').trim();
    }
  }

  customElements.define('skin-school-glossary', SkinSchoolGlossary);
}
